var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { rankPercent } from '../../utils';
import { BeatProgressBar, DinTypography, Podium } from '../styled';
import { useAiReportStore } from "../../../../store/ai-report/global-store";
import { Typography } from 'fbm-ui';
import { Stack } from 'fbm-ui/lib/mui';
import { useEffect, useMemo, useState } from 'react';
var Form = function () {
    var _a = __read(useState(''), 2), text = _a[0], setText = _a[1];
    var _b = useAiReportStore(function (store) { return [store.reportResult, store.scoreRankIntervals]; }), reportResult = _b.reportResult, scoreRankIntervals = _b.scoreRankIntervals, reportRank = _b.reportRank;
    var _c = (reportResult || {}).score, score = _c === void 0 ? 0 : _c;
    var progress = useMemo(function () { return rankPercent((reportRank === null || reportRank === void 0 ? void 0 : reportRank.rank) || 0, (reportRank === null || reportRank === void 0 ? void 0 : reportRank.total) || 0); }, [reportRank]);
    useEffect(function () {
        if (reportRank === null || reportRank === void 0 ? void 0 : reportRank.total) {
            setText("\u51FB\u8D25\u4E86".concat(progress.toFixed(0), "%\u5019\u9009\u4EBA"));
        }
        else {
            setText('');
        }
    }, [score, reportRank, scoreRankIntervals, progress]);
    return (_jsx(Podium, { children: _jsxs(Stack, __assign({ direction: "row", position: "relative", bottom: -146, left: 88, spacing: 1.5 }, { children: [_jsxs(Stack, __assign({ spacing: 1, direction: "row", justifyContent: "center", width: 300 }, { children: [_jsx(DinTypography, __assign({ sx: { fontSize: 100, fontWeight: 'bold', lineHeight: 1 }, color: "inherit" }, { children: score })), _jsx(DinTypography, __assign({ variant: "h5", color: "inherit", sx: { fontSize: 30, fontWeight: 'bold', alignSelf: 'flex-end', mb: '12px !important' } }, { children: "\u5206" }))] })), (reportRank === null || reportRank === void 0 ? void 0 : reportRank.total) !== 0 && (_jsxs(Stack, __assign({ spacing: 1, mt: 6.25 }, { children: [_jsxs(Typography, __assign({ color: "inherit", fontWeight: 500, mt: 5 }, { children: [text, "\u00A0"] })), _jsx(BeatProgressBar, { children: _jsx("div", { className: "progress-bar-fill", style: { width: "".concat(progress, "%") } }) })] })))] })) }));
};
export default Form;
